/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_Pnk_Edit_TitleInputs */

const vi_pkl_pnk_edit_title = /** @type {(inputs: Pkl_Pnk_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa phiếu nhập vật tư`)
};

/**

* @param {Pkl_Pnk_Edit_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_pnk_edit_title = /** @type {((inputs?: Pkl_Pnk_Edit_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_Pnk_Edit_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_pnk_edit_title(inputs)
});